// import { use } from "i18next";
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import '../../../styles/track.css'

type Props = {
    tracking: string;
    setTracking: (v: string) => void;

    trackLoading: boolean;
    trackErro: string | null;
    trackResp: any | null;

    onSubmit: (e?: React.FormEvent) => void;
    onBack: () => void;
};


export default function TrackStep(props: Props) {
    const navigate = useNavigate();
    const {
        tracking,
        setTracking,
        trackLoading,
        trackErro,
        trackResp,
        onSubmit,
        onBack,
    } = props;

    const shipment = trackResp?.trackResponse?.shipment?.[0];
    const pkg = shipment?.package?.[0];
    const activitiesRaw = useMemo(() => pkg?.activity || shipment?.activity || [], [pkg, shipment]);
    const activities = useMemo((): any[] => Array.isArray(activitiesRaw) ? activitiesRaw : (activitiesRaw ? [activitiesRaw] : []), [activitiesRaw]);

    const hasNoInfoYet =
        Array.isArray(shipment?.warnings) &&
        shipment.warnings.some((w: any) => w?.code === "TW0001");

    const normalizedActivities = useMemo(
        () =>
            activities.map((a) => {
                const desc =
                    a?.status?.description ||
                    a?.Description ||
                    a?.description ||
                    a?.statusDescription ||
                    "Evento";
                const date = a?.date || a?.Date || a?.dateTime || "";
                const time = a?.time || a?.Time || "";
                const loc =
                    a?.location?.address ||
                    a?.activityLocation?.address ||
                    a?.ActivityLocation?.Address ||
                    {};
                const city = loc?.city || loc?.City || "";
                const state = loc?.stateProvince || loc?.StateProvinceCode || "";
                const country = loc?.country || loc?.CountryCode || "";
                return { desc, date, time, city, state, country };
            }),
        [activities]
    );

    const last = normalizedActivities[0];

    return (
        <div id="page-ups">
            <div id="card-ups">
                <form
                    onSubmit={(e) => {
                        e?.preventDefault();
                        onSubmit();
                    }}
                    autoComplete="off"
                >
                    <h2>4- Rastreamento</h2>

                    <div>
                        <label>Tracking Number</label>
                        <input
                            value={tracking}
                            onChange={(e) => setTracking(e.target.value.trim().toUpperCase())}
                            placeholder="1Z..."
                        />
                    </div>

                    {trackErro && (
                        <div style={{ color: "crimson", marginTop: 8 }}>
                            {typeof trackErro === "string" ? trackErro : JSON.stringify(trackErro)}
                        </div>
                    )}

                    {hasNoInfoYet && (
                        <div style={{ marginTop: 8, color: "#c98d00" }}>
                            O número de rastreio é válido, mas ainda não há eventos disponíveis
                            (TW0001). Isso é comum logo após a emissão ou em ambiente de testes.
                        </div>
                    )}

                    {!hasNoInfoYet && last && (
                        <div
                            style={{
                                marginTop: 12,
                                padding: 10,
                                border: "1px solid #333",
                                borderRadius: 6,
                            }}
                        >
                            <strong>Último status:</strong> {last.desc}
                            <div style={{ opacity: 0.85 }}>
                                {last.date} {last.time}
                                {last.city ? ` • ${last.city}` : ""}
                                {last.state ? `/${last.state}` : ""}
                                {last.country ? ` • ${last.country}` : ""}
                            </div>
                        </div>
                    )}

                    {!hasNoInfoYet && normalizedActivities.length > 0 && (
                        <div style={{ marginTop: 12 }}>
                            <h4>Linha do tempo</h4>
                            <ul style={{ listStyle: "none", padding: 0 }}>
                                {normalizedActivities.map((a, i) => (
                                    <li
                                        key={i}
                                        style={{
                                            margin: "8px 0",
                                            borderLeft: "3px solid #888",
                                            paddingLeft: 8,
                                        }}
                                    >
                                        <div>
                                            <strong>{a.desc}</strong>
                                        </div>
                                        <div style={{ opacity: 0.9 }}>
                                            {a.date} {a.time}
                                            {a.city ? ` • ${a.city}` : ""}
                                            {a.state ? `/${a.state}` : ""}
                                            {a.country ? ` • ${a.country}` : ""}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {trackResp && (
                        <details style={{ marginTop: 10 }}>
                            <summary>Ver resposta bruta</summary>
                            <pre style={{ whiteSpace: "pre-wrap" }}>
                                {JSON.stringify(trackResp, null, 2)}
                            </pre>
                        </details>
                    )}

                    <div style={{ marginTop: 12 }}>
                        <button type="submit" disabled={trackLoading}>
                            {trackLoading ? "Consultando..." : "Rastrear"}
                        </button>
                        <button type="button" style={{ marginLeft: 8 }} onClick={onBack}>
                            Voltar
                        </button>
                        <button type="button" style={{ marginLeft: 8 }} onClick={() => navigate("/dashboard")}>
                            Home
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
